import { useQuery } from '@apollo/client';
import GET_PRICE_GRAPH_DETAIL from './priceGraphDetail.gql';

export interface IFare {
  // itineraryId: string;
  searchDate: string;
  // cabinClass: string;
  lowestFare: number;
  // reservationFare: number;
  // eventFareType: string;
}

interface IPriceGraphDetail {
  averageLowestFare: number;
  // averageReservationFare: number;
  fares: IFare[];
}

interface IData {
  priceGraphDetail: IPriceGraphDetail;
}

export default function usePriceGraphDetail(variables: {
  itineraryId: string;
  cabinClass: string;
  includeEventFare: boolean;
  period: number;
}) {
  const { data } = useQuery<IData>(GET_PRICE_GRAPH_DETAIL, { variables });
  return data?.priceGraphDetail;
}
